<template>
  <div>
    <el-row>
      <rabbey-toolbox
        class="mt-1"
        :filterables="true"
        @filter-search="onFilterSearch"
      >
        <YearComponent
          ref="yearC"
          :initial="2019"
          @change="handler_year"
          v-model="year"
        ></YearComponent>
      </rabbey-toolbox>
      <!-- <el-col :span="22">ㅤ</el-col>
      <el-col :span="2"> </el-col> -->
    </el-row>

    <el-row>
      <el-col>
        <el-tabs
          v-model="activeTab"
          type="card"
          ref="tabs"
          @tab-click="handleClick"
        >
          <el-tab-pane v-for="(name, key) in tabName" :key="key" :label="name">
            <RabbeyTable3
              :data="dataFilter"
              :loading="loading"
              :show-summary="true"
              :summary-method="getTotalByMonthDeals"
              :columns="columns"
            />
          </el-tab-pane>
        </el-tabs>
      </el-col>
    </el-row>
    <ReportAccountsPayableDetail ref="detail" />
  </div>
</template>

<script>
import RabbeyTable3 from "@/components/RabbeyTable3.vue";
import ReportAccountsPayableDetail from "./ReportAccountsPayableDetail.vue";
import HyperLinkPayable from "@/components/functionals/HyperLinkPayable.vue";
import YearComponent from "@/components/Global_System/YearsComponent.vue";
import { formatterMoney } from "@/utils";

export default {
  name: "ReportAccountsPayable",
  components: {
    RabbeyTable3,
    ReportAccountsPayableDetail,
    YearComponent
  },
  data() {
    return {
      loading: false,
      loadingTabs: false,
      year: null,
      columns: [
        {
          prop: "Name",
          label: "Nombre",
          // width: 200,
          align: "left",
          fixed: true,
          sortable: true
        },
        {
          prop: "TotalExpiration",
          label: "Total",
          align: "right",
          attrs: {
            openSelect: this.openSelect
          },
          formatter: HyperLinkPayable,
          sortable: true
          // formatter: (row) =>
          //   parseFloat(row.TotalExpiration).toLocaleString("en")
        },
        {
          prop: "TotalOnTime",
          label: "Pagos al dia",
          attrs: {
            openSelect: this.openSelect
          },
          formatter: HyperLinkPayable,
          align: "right",
          sortable: true
        },
        {
          prop: "tenDayExpiration",
          label: "10D",
          attrs: {
            openSelect: this.openSelect
          },
          // formatter: (row) => formatterMoney(row.Amount),
          formatter: HyperLinkPayable,
          align: "right",
          sortable: true
        },
        {
          prop: "thirtyDayExpiration",
          label: "30D",
          attrs: {
            openSelect: this.openSelect
          },
          formatter: HyperLinkPayable,
          align: "right",
          sortable: true
        },
        {
          prop: "ninetyDayExpiration",
          label: "90D >",
          attrs: {
            openSelect: this.openSelect
          },
          formatter: HyperLinkPayable,
          align: "right",
          sortable: true
        }
      ],
      data: [],
      dataFilter: [],
      tabName: [
        "Proveedores",
        "Accionistas",
        "Bancos",
        "Empleados",
        "Relacionado"
      ],
      activeTab: "0"
    };
  },
  methods: {
    formatterMoney,
    getTotalByMonthDeals(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "Totales";
          return;
        }
        const values = data.map((item) => Number(item[column.property]));
        if (!values.every((value) => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
        } else {
          sums[index] = "";
        }
      });

      const result = [];
      sums.forEach((value, index) => {
        if (index === 0) {
          result[index] = value;
          return;
        }

        const formatter = new Intl.NumberFormat("es-DO", {
          stlye: "currency",
          currency: "DOP",
          minimumFractionDigits: 2
        });

        const f = formatter.format(value).replace(/,/g, "").replace(".", ".");
        result[index] = Number(parseFloat(f).toFixed(2)).toLocaleString("en");
        return;
      });

      return result;
    },
    onFilterSearch(query) {
      this.loading = true;
      this.dataFilter = this.data.filter((x) =>
        x.Name.includes(query.trim().toUpperCase())
      );
      this.loading = false;
    },
    getAccountsPayable() {
      this.loading = true;
      this.data = null;

      const activeTabName = this.tabName[this.activeTab];
      const params = {
        Type: activeTabName,
        Anio: this.year
      };

      this.$http
        .get("/api/invoices/GetAccountsPayable", {
          timeout: 999999999,
          params
        })
        .then(({ data }) => {
          this.data = data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handler_year(_year) {
      this.year = _year;
      this.getAccountsPayable();
    },
    openSelect(props) {
      this.$refs.detail.show({
        year: this.year,
        props,
        activeTab: this.activeTab
      });
    },
    handleClick(obj) {
      const index = obj.index;

      this.activeTab = index;
      this.getAccountsPayable();
    }
  },
  watch: {
    data() {
      this.dataFilter = this.data;
    }
  },
  created() {
    this.year = new Date().getFullYear();
    this.getAccountsPayable();
  }
};
</script>

<style></style>
